export default {
    init() {
        this.prefix = 'mobile-sidebar-menu';
        this.state = false;
        this.$cont = $(`.${this.prefix}`);
        this.buildMenu();

        $('.header-middle__m-menu-toggler').on('click', this.onHamburgerClick.bind(this));
        $(`.${this.prefix}__scroll`).on('click', this.onOverlayClick.bind(this));

        $(`.${this.prefix}-item--with-children > .${this.prefix}-item__link`).on('click', this.onItemWithChildrenClick.bind(this));
    },

    buildMenu() {
        $('.catalog-wide-menu').clone().children().each((index, el) => {
            $(`.${this.prefix}__menu`).append(el);
        });

        $(`.${this.prefix}__menu`).find('.catalog-wide-menu-item').each((index, el) => {
            $(el).removeClass('catalog-wide-menu-item').addClass(`${this.prefix}-item`);
            $(el).find('.catalog-wide-menu-item__submenu').removeClass('catalog-wide-menu-item__submenu').addClass(`${this.prefix}-item__submenu`);
            $(el).find('.catalog-wide-menu-item__link').removeClass('catalog-wide-menu-item__link').addClass(`${this.prefix}-item__link`);

            if ($(el).hasClass('catalog-wide-menu-item--level-1')) {
                $(el).removeClass('catalog-wide-menu-item--level-1').addClass(`${this.prefix}-item--level-1`);
                $(el).find('.catalog-wide-menu-item__link--level-1').removeClass('catalog-wide-menu-item__link--level-1').addClass(`${this.prefix}-item__link--level-1`);
            }

            if ($(el).hasClass('catalog-wide-menu-item--level-2')) {
                $(el).removeClass('catalog-wide-menu-item--level-2').addClass(`${this.prefix}-item--level-2`);
                $(el).find('.catalog-wide-menu-item__link--level-2').removeClass('catalog-wide-menu-item__link--level-2').addClass(`${this.prefix}-item__link--level-2`);
            }

            $(el).find('.catalog-wide-menu-item__image').remove();

            if ($(el).find(`.${this.prefix}-item__submenu`).length > 0) {
                $(el).addClass(`${this.prefix}-item--with-children`);
            }
        });

        $(`.${this.prefix}__menu .catalog-wide-menu-item--node`).removeClass('catalog-wide-menu-item--node');

        /*const $storeManager = $('.header-middle__store-manager .store-manager').clone();
        $(`.mobile-sidebar-store-manager`).append($storeManager);*/
        //$(`.mobile-sidebar-store-manager .store-manager__store`).addClass('store-manager-custom-trigger');

        setTimeout(() => {
            app.pageController.site.storeManager.rebindCustomTrigger();
        }, 100);
    },


    onHamburgerClick(e) {
        e.preventDefault();

        if (this.state) {
            this.hide();
        } else {
            this.show();
        }
    },

    show() {
        this.state = true;
        this.$cont.toggleClass(`${this.prefix}--active`, true);
        $('body').css('overflow', 'hidden');
    },

    hide() {
        this.state = false;
        this.$cont.toggleClass(`${this.prefix}--active`, false);
        $('body').css('overflow', '');
    },

    onOverlayClick(e) {
        if (e.target !== e.currentTarget) {
            return;
        }

        this.hide();
    },

    onItemWithChildrenClick(e) {
        e.preventDefault();
        $(e.currentTarget).closest(`.${this.prefix}-item`).toggleClass(`${this.prefix}-item--expanded`);
        $(e.currentTarget).siblings(`.${this.prefix}-item__submenu`).slideToggle();
    },
};
